// extracted by mini-css-extract-plugin
export default {"closeIcon":"KotlettBugreport__closeIcon--1xeUl","customButton":"KotlettBugreport__customButton--2OE9R","image":"KotlettBugreport__image--1EAiw"};